import React, { useEffect, useState } from 'react';
import {
  Container,
  Form,
  Row,
  Col,
  Button,
} from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import ListTables from '../../shared/tables';

//infopaintinspection
function FormInfoPaint({ id }) {
  const [selectstate, setSelectState] = useState('');
  const [states, setStates] = useState([]);
  const [infoPaint, setInfoPaint] = useState([]);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')

  const saveForm = (e) => {
    e.preventDefault()
    infoPaint.push({
      id_state: selectstate,
    });
    setSelectState('');
    setInfoPaint(infoPaint);
    //generalUpdate('infoPaint', infoPaint);
  };

  const deleteItem = (idx) => {
    infoPaint.splice(idx-1, 1);
    setInfoPaint([...infoPaint]);
    //generalUpdate('infoPaint', infoPaint);
  };

  const editButton = (row) => {
    return (
      <Button
        title="Modificar Combustible"
        text="Editar"
        variant="outline-primary"
        onClick={()=>deleteItem(row.id)}
      >Eliminar</Button>
    );
  };

  const infoTable =()=>{
    // {type: 'C', id_part: '11', id_state: '1'} 
    let tmpTable =[]
    for (let index = 0; index < infoPaint.length; index++) {
      const element = infoPaint[index];
      const currentstate = states.find((e)=> e.id.toString() === element.id_state.toString())
      if(currentstate)tmpTable.push({id: (index+1), estado:currentstate.name})
    }
    return(<ListTables 
      data={tmpTable}
      editar={editButton}
      messageWd={'Agrege una parte'}
      />)
  }

  const sendInfo = async (event) => {
    event.preventDefault();
    const body = {
      type:'P',  
      data: infoPaint
    };
    const respo = await post('/peritaje/modifyinspection/paint/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };

  useEffect(() => {
    const initForm = async () => {
      const body = {type:'P'};
      const respo = await post('/peritaje/infodetailinspection/paint/'+id, body);
      if(respo.success){
        const {detail} = respo.data;
        setInfoPaint(detail);
      }
    };


  const getInfoChassis = async () => {
    const respoInfo = await get( `/peritaje/infopaintinspection/` ,  {});
    if (respoInfo.success) {
      const { paintwork } = respoInfo.data;
      setStates(paintwork);
    } else {
      console.log(respoInfo.message);
    }
  };

    getInfoChassis();
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Pintura</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form onSubmit={saveForm}>
          <Form.Label htmlFor="estado">Estado</Form.Label>
          <Form.Select
            name="selectstate"
            value={selectstate}
            onChange={(e) => setSelectState(e.target.value)}
            aria-label="Default select example"
            required
          >
            <option value="">Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
          <Row className="my-3">
            <Col className="d-flex justify-content-end">
              <Button
                type="submit"
                variant="primary"
              >
                Agregar Novedad
              </Button>
            </Col>
          </Row>
            </Form>
        </Col>
        <Col>{infoTable()}</Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo} >
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormInfoPaint;
